import React, { Fragment, PureComponent } from 'react';
import { Card, Spin } from 'antd';
import { connect } from 'dva';
import router from 'umi/router';
import withRouter from 'umi/withRouter';
import moment from 'moment';

import ResourcesFinderHeader from './components/ResourcesFinderHeader';
import RenderFilters from './components/RenderFilters';
import RenderSelectedFilters from './components/RenderSelectedFilters';
import ResourceRiskTable from './ResourceRiskTable';
import NoCloudAccountSelected from '../ReportView/NoCloudAccountSelected/NoCloudAccountSelected';
import { getHistoricalDate } from '../../utils/getHistoricalDate';

@connect(({ cloudAccount, organisation, universalDrawer, resourcesReport }) => ({
  allCloudAccountsList: cloudAccount.allCloudAccountsList,
  organisation: organisation.current,
  spRisks: organisation.spRisks,
  filteredResources: universalDrawer.filteredResources,
  counts: universalDrawer.counts,
  resourcesReport: resourcesReport.report,
  appliedFilters: universalDrawer.appliedFilters,
  selectedDate: universalDrawer.selectedDate,
  drawerLoading: universalDrawer.loading,
  selectedCloudAccounts: cloudAccount.selectedCloudAccounts,
}))
class ResourcesFinder extends PureComponent {
  state = {
    showSuppress: false,
    selectedDate: 'Select Date',
  };

  componentDidMount() {
    const { dispatch, allCloudAccountsList, organisation } = this.props;
    // dispatch getFilteredResources here
    dispatch({
      type: 'universalDrawer/getFilteredResources',
      payload: {
        limit: 0,
        showSuppress: this.state.showSuppress,
      },
    });
    dispatch({
      type: 'resourcesReport/getReport',
      payload: {
        orgId: organisation.id,
        cloudAccounts: allCloudAccountsList.map(v => v.id),
      },
    });
  }

  componentDidUpdate(prevProps, prevState) {
    // check if appliedFilters have changed
    const { dispatch, resourcesReport, organisation, allCloudAccountsList } = this.props;

    if (prevState.showSuppress !== this.state.showSuppress) {
      dispatch({
        type: 'universalDrawer/getFilteredResources',
        payload: {
          limit: 0,
          showSuppress: this.state.showSuppress,
        },
      });
    }

    // if (JSON.stringify(prevProps.resourcesReport) !== JSON.stringify(resourcesReport)) {
    //   // dispatch getFilteredResources here
    //   dispatch({
    //     type: 'universalDrawer/getFilteredResources',
    //     payload: {
    //       limit: 0,
    //       showSuppress: this.state.showSuppress,
    //     },
    //   });
    // }

    if (prevProps.appliedFilters !== this.props.appliedFilters) {
      // if (JSON.stringify(prevProps.appliedFilters) !== JSON.stringify(this.props.appliedFilters)) {

      dispatch({
        type: 'universalDrawer/getFilteredResources',
        payload: {
          limit: 0,
          showSuppress: this.state.showSuppress,
        },
      });
    }

    if (prevProps.spRisks !== this.props.spRisks) {
      dispatch({
        type: 'universalDrawer/getFilteredResources',
        payload: {
          limit: 0,
          showSuppress: this.state.showSuppress,
        },
      });
    }
  }

  handleSearch = (params, drawerType) => {
    const { selectedCloudAccounts, organisation } = this.props;
    let filterAccountsId = selectedCloudAccounts.map(val => val.id);
    const { type, value } = params;
    let extraObj = [
      {
        type: type,
        value,
      },
      {
        type: 'history',
        value: [moment(new Date())],
      },
    ];

    if (!value) {
      extraObj = extraObj.filter(extraObj => extraObj.type !== 'search');
    }
    extraObj.push({
      type: 'cloudAccounts',
      value: filterAccountsId,
    });
    extraObj = JSON.stringify(extraObj);
    let urlQuery = `?org=${organisation.id}&filters=${extraObj}&dType=${drawerType}`;
    router.push(urlQuery);
  };

  onSuppressSwitchChange = checked => {
    this.setState({
      showSuppress: checked,
    });
  };

  applyFilter = rules => {
    let rulesStringify = JSON.stringify(rules);
    const url = window.location.search;
    let modifiedUrl = url.replace(/(filters=)[^\&]+/, `$1${  rulesStringify}`);
    router.push(modifiedUrl);
  };

  clearSelected = () => {
    const { dispatch } = this.props;
    dispatch({
      type: 'universalDrawer/saveSelectedDate',
      payload: {
        selectedDate: moment(new Date()),
      },
    });
    this.setState({
      selectedDate: 'Select Date',
    });
    let cloudObj = this.props.appliedFilters.filter(v => v.type === 'cloudAccounts');
    // let extraObjStringify = JSON.stringify([]);
    cloudObj.push({
      type: 'history',
      value: [moment(new Date())],
    });
    let extraObjStringify = JSON.stringify(cloudObj);
    const url = window.location.search;
    let modifiedUrl = url.replace(/(filters=)[^\&]+/, `$1${  [extraObjStringify]}`);
    router.push(modifiedUrl);
  };

  handleCheckbox = (e, obj, mainIndex, subIndex) => {
    let ec2Array = [
      'EC2:Instance',
      'EC2:Volume',
      'EC2:ElasticIP',
      'EC2:RI',
      'EC2:SecurityGroups',
      'EC2:SnapShot',
    ];
    let { appliedFilters } = this.props;
    let { value, checked } = e.target;
    if (value === 'Global') {
      value = '';
    }
    let { type } = obj;
    let currentFilterObj = appliedFilters.find(v => v.type === type);
    if (checked) {
      // push to url
      if (!currentFilterObj) {
        // prepare new obj and push into url along with appliedRules
        let newObj = {
          type,
          value: [value],
        };
        if (value === 'EC2') {
          newObj.value = ec2Array;
        }

        appliedFilters.push(newObj);
        this.applyFilter(appliedFilters);
        return;
      }

      if (currentFilterObj) {
        // get current obj update it and push into url along with appliedRules
        let newValue = currentFilterObj.value;
        if (value === 'EC2') {
          newValue = newValue.concat(ec2Array);
        } else {
          newValue.push(value);
        }
        let newObj = {
          type: currentFilterObj.type,
          value: newValue,
        };
        appliedFilters = appliedFilters.filter(v => v.type !== type);
        appliedFilters.push(newObj);
        this.applyFilter(appliedFilters);
        
      }
    } else {
      let filterValues;
      if (currentFilterObj) {
        // get currentObjValue;
        let newValue = currentFilterObj.value;
        if (value === 'EC2') {
          filterValues = newValue.filter(v => !ec2Array.includes(v));
        } else {
          filterValues = newValue.filter(v => v !== value);
        }
        let newObj = {
          type: currentFilterObj.type,
          value: filterValues,
        };
        appliedFilters = appliedFilters.filter(v => v.type !== type);
        if (filterValues.length === 0) {
          this.applyFilter(appliedFilters);
        } else {
          appliedFilters.push(newObj);
          this.applyFilter(appliedFilters);
        }
      }
      
    }
  };

  handleHistoryChange = e => {
    let { appliedFilters, dispatch } = this.props;

    let filterDate = moment(new Date(e)).format('YYYY-MM-DD');

    let todayDate = moment(new Date()).format('YYYY-MM-DD');

    if (todayDate === filterDate) {
      this.setState({
        selectedDate: 'Select Date',
      });
    } else {
      this.setState({
        selectedDate: filterDate,
      });
    }

    dispatch({
      type: 'universalDrawer/saveSelectedDate',
      payload: {
        selectedDate: e,
      },
    });

    appliedFilters = appliedFilters.filter(v => v.type !== 'history');

    if (e) {
      let date = getHistoricalDate(e);
      let historyFilter = {
        type: 'history',
        value: [date.endTime],
      };
      appliedFilters.push(historyFilter);
    }

    this.applyFilter(appliedFilters);
  };

  render() {
    let {
      allCloudAccountsList,
      selectedCloudAccounts,
      filteredResources,
      drawerLoading,
      counts,
      organisation,
      appliedFilters,
      resourcesReport,
    } = this.props;
    const { showSuppress, selectedDate } = this.state;
    if (allCloudAccountsList === null) {
      return <NoCloudAccountSelected />;
    }

    let tableProps = {
      filteredResources,
      drawerLoading,
      counts,
      showSuppress,
      selectedCloudAccounts,
      organisation,
      allCloudAccountsList,
      appliedFilters,
      dispatch: this.props.dispatch,
    };

    let filterProps = {
      allCloudAccountsList,
      selectedCloudAccounts,
      selectedDate,
      propSelectedDate: this.props.selectedDate,
      appliedFilters,
      handleCheckbox: this.handleCheckbox,
      handleHistoryChange: this.handleHistoryChange,
    };

    let appliedFiltersProps = {
      filteredResources,
      appliedFilters,
      allCloudAccountsList,
      counts,
      onChange: this.onSuppressSwitchChange,
      clearSelected: this.clearSelected,
    };

    return (
      <Fragment>
        <Card bordered={false} style={{ fontSize: 14, margin: '0px -27px' }}>
          <ResourcesFinderHeader handleSearch={this.handleSearch} />
          <RenderFilters {...filterProps} />
          <RenderSelectedFilters {...appliedFiltersProps} />
        </Card>
        <ResourceRiskTable {...tableProps} />
      </Fragment>
    );
  }
}

export default withRouter(ResourcesFinder);
